import * as yup from 'yup';
import {
    companyNameSchema,
    companySectorSchema,
    companySizeSchema,
} from '../auth.validation';

export const companyProfileSchema = () => yup
    .object()
    .shape({
        companyName: companyNameSchema,
        companySector: companySectorSchema,
        companySize: companySizeSchema,
    });
